import styled from '@emotion/styled';

function DefaultCheckedIcon() {
    return (
        <Wrapper>
            <Ring>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.67688 17.8565C5.6727 18.3122 4.60132 18.6022 3.50438 18.7153C3.43195 18.7228 3.35889 18.7091 3.29413 18.6758C3.22937 18.6425 3.17571 18.5911 3.13969 18.5278C2.32688 17.0953 2.05969 15.3131 2.38969 13.3575C2.81063 10.8337 4.17938 8.30715 6.24469 6.24183C8.31 4.17652 10.8384 2.80777 13.3603 2.38683C15.4969 2.03152 17.4263 2.38683 18.9188 3.38058C18.9798 3.42069 19.0279 3.47778 19.0569 3.54481C19.086 3.61185 19.0949 3.68591 19.0824 3.75792C19.07 3.82992 19.0368 3.89671 18.9869 3.95009C18.937 4.00348 18.8726 4.04112 18.8016 4.0584C18.099 4.22587 17.414 4.46005 16.7559 4.75777C14.715 5.6859 12.1059 7.66965 11.2697 11.8546C10.6969 14.6934 9.15281 16.7128 6.67688 17.8565ZM20.8603 5.47308C20.8244 5.40995 20.7708 5.35863 20.7063 5.32534C20.6417 5.29206 20.5688 5.27824 20.4966 5.28558C19.3992 5.39787 18.3274 5.6879 17.3231 6.14433C14.8472 7.28808 13.3031 9.30746 12.735 12.1443C11.8978 16.3293 9.28969 18.3131 7.24875 19.2412C6.5907 19.5389 5.90571 19.7731 5.20313 19.9406C5.13053 19.957 5.06446 19.9946 5.0133 20.0486C4.96215 20.1027 4.92823 20.1707 4.91586 20.2441C4.9035 20.3175 4.91325 20.3929 4.94387 20.4607C4.97449 20.5285 5.0246 20.5857 5.08781 20.625C6.20063 21.3675 7.55531 21.75 9.05813 21.75C9.58968 21.7484 10.1202 21.7032 10.6444 21.615C13.1672 21.194 15.6947 19.8253 17.76 17.76C19.8253 15.6946 21.1941 13.1662 21.615 10.6443C21.9375 8.68871 21.6731 6.90558 20.8603 5.47308Z" fill="#F3F0ED"/>
                </svg>
            </Ring>
        </Wrapper>
    );
}

const Wrapper = styled.div`
    width: 100%;
    aspect-ratio: 1;
    background-color: var(--color-primary);
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const Ring = styled.div`
    padding: 6px;
    border: 1.5px solid white;
    width: 80%;
    aspect-ratio: 1;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export default DefaultCheckedIcon;
